import { render, staticRenderFns } from "./RankNews.vue?vue&type=template&id=27d8b8a3&"
import script from "./RankNews.vue?vue&type=script&lang=js&"
export * from "./RankNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports